// @ts-nocheck
import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { FormFieldPresentationProps } from "@insite/mobius/FormField";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointValues, {
    BreakpointValue,
    BreakpointValueProp,
} from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getArray from "@toolkit/Framework/Common/Utilities/getArray";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

const wrapperBorderWidth = "1px";

const infoLabelProps: TypographyPresentationProps = {
    variant: null as any,
    forwardAs: "div",
    css: css`
        ${({ theme }) => css`
            font-size: ${theme.design.typography.size.tiny};
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `};
    `,
};

const infoValueProps: TypographyPresentationProps = {
    forwardAs: "div",
    css: css`
        line-height: ${x => x.theme.design.typography.lineHeight.small};
    `,
};

const getWrapperGapStyles = (gap: BreakpointValueProp | undefined) => {
    if (!gap) {
        return null;
    }

    const _gap = getArray(gap);

    return css`
        &.line + .line:not(.child) {
            ${breakpointValues(_gap, "margin-top")}
        }
    `;
};

export interface ProductLineV2Props {
    wrapperBorderWidth: string;
    wrapper?: InjectableCss;
    infoFormField?: FormFieldPresentationProps<any>;
    infoLabel?: TypographyPresentationProps;
    infoSmallHeadingAndText?: SmallHeadingAndTextStyles;
    infoValue?: TypographyPresentationProps;
    getWrapperGapStyles: typeof getWrapperGapStyles;
    boxPaddingValues: BreakpointValue[];
}

export const productLineV2Props: ProductLineV2Props = {
    wrapperBorderWidth,
    wrapper: {
        css: css`
            position: relative;
            background-color: ${getColor("common.background")};
            border: ${wrapperBorderWidth} solid ${getColor("common.borderLight")};
            border-radius: ${pxToRem(8)};

            &:has(+ .child) {
                border-bottom-right-radius: 0;

                + .child {
                    border-top-right-radius: 0;
                    border-top-left-radius: 0;
                }
            }

            &.child {
                margin-top: -${wrapperBorderWidth};
                ${breakpointValues(["8%", null, null, null, pxToRem(120)], "margin-left")}

                &:has(+ .child) {
                    border-bottom-right-radius: 0;
                    border-bottom-left-radius: 0;
                }
            }
        `,
    },
    infoFormField: {
        labelProps: infoLabelProps,
        sizeVariant: "xsmall" as any,
        mergeCss: true,
        cssOverrides: {
            formInputWrapper: css`
                &&&:not(:first-child) {
                    margin-top: ${pxToRem(3)};
                }
            `,
        },
    },
    infoLabel: infoLabelProps,
    infoSmallHeadingAndText: {
        heading: infoLabelProps,
        text: infoValueProps,
    },
    infoValue: infoValueProps,
    getWrapperGapStyles,
    boxPaddingValues: pxToRemArray([16, 20, null, 24]),
};
